export function retryPromise<T>(
  promise: () => Promise<T>,
  options?: { max?: number; delay?: number; name?: string },
): Promise<T> {
  const { max = 20, delay = 1000, name } = options ?? {}
  return new Promise((resolve, reject) => {
    function attempt(currentMax: number) {
      promise()
        .then(resolve)
        .catch((error) => {
          if (currentMax > 1) {
            console.error(
              `retryPromise '${name ?? ''}' fail, trying time ${
                max - currentMax
              }`,
            )
            // 还有重试机会，延迟一段时间后进行重试
            setTimeout(() => {
              attempt(currentMax - 1)
            }, delay)
          } else {
            // 重试次数耗尽，将错误传递给外部 Promise
            reject(error)
          }
        })
    }

    attempt(max)
  })
}
